<template>
  <div>
    <b-table-simple hover small bordered responsive>
      <b-thead>
        <b-tr>
          <b-th>#</b-th>
          <b-th>Thành viên</b-th>
          <b-th>Loại</b-th>
          <b-th>Mới</b-th>
          <b-th>Nợ cũ</b-th>
          <b-th>Nạp rút</b-th>
          <b-th>Tổng</b-th>
          <b-th></b-th>
        </b-tr>
      </b-thead>
      <b-tbody v-for="row in listReport" :key="row.custom_id" v-b-modal.modal-3 @click="openHistoryModal(row)" class="pointer-cursor">
        <b-tr v-if="row.bothCurrency">
          <b-td rowspan="2">{{row.stt}}</b-td>
          <b-td rowspan="2" class="text-left">{{row.name}}</b-td>
          <b-td class="text-center"><b-badge variant="orange">VND</b-badge></b-td>
          <b-td class="text-right"><span :style="applyNumberStyle(row.accounting.vnd)">{{ applyNumberFormat(row.accounting.vnd,'th') }}</span></b-td>
          <b-td class="text-right"><span :style="applyNumberStyle(row.owe.vnd)">{{ applyNumberFormat(row.owe.vnd,'th') }}</span></b-td>
          <b-td class="text-right">
            <span :style="applyNumberStyle(row.transaction.vnd)">{{ applyNumberFormat(row.transaction.vnd,'th') }}</span>
<!--            <editable-number format-currency="th" :amount="row.transaction.vnd" :row="row" currency-id="1" />-->
<!--            <i style="font-size: 14px" class="las la-exchange-alt" v-b-modal.modal-2 @click="openDepositModal(row,'1', row.all.vnd)"></i>-->
          </b-td>
          <b-td class="text-right"><span :style="applyNumberStyle(row.all.vnd)">{{ applyNumberFormat(row.all.vnd,'th') }}</span></b-td>
          <b-td @click.stop="openDepositModal(row,'1', row.all.vnd)">
             <i style="font-size: 14px" class="las la-exchange-alt"></i>
          </b-td>
        </b-tr>
        <b-tr v-if="row.bothCurrency">
          <b-td class="text-center"><b-badge variant="light-blue">USD</b-badge></b-td>
          <b-td class="text-right"><span :style="applyNumberStyle(row.accounting.usd)">{{ applyNumberFormat(row.accounting.usd,'en') }}</span></b-td>
          <b-td class="text-right"><span :style="applyNumberStyle(row.owe.usd)">{{ applyNumberFormat(row.owe.usd,'en') }}</span></b-td>
          <b-td class="text-right">
            <span :style="applyNumberStyle(row.transaction.usd)">{{ applyNumberFormat(row.transaction.usd,'en') }}</span>
<!--            <editable-number format-currency="en" :amount="row.transaction.usd" :row="row" currency-id="2"/>-->
<!--            <i style="font-size: 14px" class="las la-exchange-alt"  @click.stop="openDepositModal(row,'2', row.all.usd)"></i>-->
          </b-td>
          <b-td class="text-right"><span :style="applyNumberStyle(row.all.usd)">{{ applyNumberFormat(row.all.usd,'en') }}</span></b-td>
          <b-td @click.stop="openDepositModal(row,'2', row.all.usd)">
             <i style="font-size: 14px" class="las la-exchange-alt"></i>
          </b-td>
        </b-tr>
        <b-tr v-if="row.onlyVND">
          <b-td rowspan="2">{{row.stt}}</b-td>
          <b-td rowspan="2" class="text-left">{{row.name}}</b-td>
          <b-td class="text-center"><b-badge variant="orange">VND</b-badge></b-td>
          <b-td class="text-right"><span :style="applyNumberStyle(row.accounting.vnd)">{{ applyNumberFormat(row.accounting.vnd,'th') }}</span></b-td>
          <b-td class="text-right"><span :style="applyNumberStyle(row.owe.vnd)">{{ applyNumberFormat(row.owe.vnd,'th') }}</span></b-td>
          <b-td class="text-right">
            <span :style="applyNumberStyle(row.transaction.vnd)">{{ applyNumberFormat(row.transaction.vnd,'th') }}</span>
<!--            <editable-number format-currency="th" :amount="row.transaction.vnd" :row="row" currency-id="1" />-->
<!--            <i style="font-size: 14px" class="las la-exchange-alt"  @click.stop="openDepositModal(row,'1', row.all.vnd)"></i>-->
          </b-td>
          <b-td class="text-right"><span :style="applyNumberStyle(row.all.vnd)">{{ applyNumberFormat(row.all.vnd,'th') }}</span></b-td>
          <b-td @click.stop="openDepositModal(row,'1', row.all.vnd)">
             <i style="font-size: 14px" class="las la-exchange-alt"></i>
          </b-td>
        </b-tr>
        <b-tr v-if="row.onlyUSD">
          <b-td rowspan="2">{{row.stt}}</b-td>
          <b-td rowspan="2" class="text-left">{{row.name}}</b-td>
          <b-td class="text-center"><b-badge variant="light-blue">USD</b-badge></b-td>
          <b-td class="text-right"><span :style="applyNumberStyle(row.accounting.usd)">{{ applyNumberFormat(row.accounting.usd,'en') }}</span></b-td>
          <b-td class="text-right"><span :style="applyNumberStyle(row.owe.usd)">{{ applyNumberFormat(row.owe.usd,'en') }}</span></b-td>
          <b-td class="text-right">
            <span :style="applyNumberStyle(row.transaction.usd)">{{ applyNumberFormat(row.transaction.usd,'en') }}</span>
<!--            <editable-number format-currency="en" :amount="row.transaction.usd" :row="row" currency-id="2" />-->
<!--            <i style="font-size: 14px" class="las la-exchange-alt"  @click.stop="openDepositModal(row,'2', row.all.usd)"></i>-->
          </b-td>
          <b-td class="text-right"><span :style="applyNumberStyle(row.all.usd)">{{ applyNumberFormat(row.all.usd,'en') }}</span></b-td>
          <b-td @click.stop="openDepositModal(row,'2', row.all.usd)">
             <i style="font-size: 14px" class="las la-exchange-alt"></i>
          </b-td>
        </b-tr>
      </b-tbody>
      <b-tfoot v-if="detailReport.summary_report && detailReport.summary_success_report">
         <b-tr>
          <b-td rowspan="2"></b-td>
          <b-td rowspan="2" align="middle" style="vertical-align: middle;"><b>TỔNG</b></b-td>
          <b-td align="center"><b>VND</b></b-td>
          <b-td align="right" :style="applyNumberStyle(detailReport.summary_report.all.vnd)">{{applyNumberFormat(detailReport.summary_report.all.vnd, 'th')}}</b-td>
          <b-td align="right" :style="applyNumberStyle(detailReport.summary_success_report.owe.vnd)">{{applyNumberFormat(detailReport.summary_success_report.owe.vnd, 'th')}}</b-td>
          <b-td align="right" :style="applyNumberStyle(detailReport.summary_success_report.transaction.vnd)">{{applyNumberFormat(detailReport.summary_success_report.transaction.vnd, 'th')}}</b-td>
          <b-td align="right" :style="applyNumberStyle(detailReport.summary_success_report.all.vnd)">{{applyNumberFormat(detailReport.summary_success_report.all.vnd, 'th')}}</b-td>
          <b-td></b-td>
        </b-tr>
        <b-tr>
          <b-td align="center"><b>USD</b></b-td>
          <b-td align="right" :style="applyNumberStyle(detailReport.summary_report.all.usd)">{{applyNumberFormat(detailReport.summary_report.all.usd, 'en')}}</b-td>
          <b-td align="right" :style="applyNumberStyle(detailReport.summary_success_report.owe.usd)">{{applyNumberFormat(detailReport.summary_success_report.owe.usd, 'en')}}</b-td>
          <b-td align="right" :style="applyNumberStyle(detailReport.summary_success_report.transaction.usd)">{{applyNumberFormat(detailReport.summary_success_report.transaction.usd, 'en')}}</b-td>
          <b-td align="right" :style="applyNumberStyle(detailReport.summary_success_report.all.usd)">{{applyNumberFormat(detailReport.summary_success_report.all.usd, 'en')}}</b-td>
          <b-td></b-td>
        </b-tr>
      </b-tfoot>
    </b-table-simple>
    <b-modal id="modal-2" title="Nạp / rút" ok-title="Xác nhận" cancel-title="Đóng" size="sm">
      <template #modal-header>
          <h4><i class="las la-exchange-alt"/> NẠP / RÚT</h4>
      </template>
      <template #default>
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
            <b-form>
              <b-form-group label="Chọn khách hàng">
                <v-select v-model="modal.customer" :reduce="opt => opt.id" :options="customerOptions" placeholder="Chọn khách hàng"/>
              </b-form-group>
              <b-form-group label="Chọn chu kỳ">
                <v-select plain v-model="modal.payment_cycle" :reduce="opt => opt.id" :options="rangeReportOptions" placeholder="Chọn chu kì"/>
              </b-form-group>
              <b-form-group label="Loại tiền" label-md="3">
                <b-form-radio inline v-model="modal.money_type" value="1">VND</b-form-radio>
                <b-form-radio inline v-model="modal.money_type" value="2">USD</b-form-radio>
              </b-form-group>
              <b-form-group label="Giao dịch" label-md="3">
                <b-form-radio inline v-model="modal.payment_type" name="customRadio2" value="payment">Thanh toán</b-form-radio>
                <b-form-radio inline v-model="modal.payment_type" name="customRadio2" value="other">Khác</b-form-radio>
              </b-form-group>
              <b-form-group label="Số tiền">
                <vue-numeric v-model="modal.payment_amount" minus class="form-control" style="text-align: right;" placeholder="nhập số" currency-symbol-position="suffix" output-type="Number"></vue-numeric>
              </b-form-group>
              <b-form-group label="Ghi chú">
                <b-form-textarea v-model="modal.note" rows="3" style="line-height: 20px"></b-form-textarea>
              </b-form-group>
              <span class="text-danger" v-html="serverError"></span>
            </b-form>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <b-button variant="primary" @click="confirm" :disabled="serverRequesting">Xác nhận</b-button>
        <b-button variant="default" @click="$bvModal.hide('modal-2')">Đóng</b-button>
      </template>
    </b-modal>
    <b-modal id="modal-3" title="Lịch sử nạp / rút" ok-title="Xác nhận" cancel-title="Đóng" size="sm">
      <template #modal-header>
          <h4><i class="las la-list-alt"/> LỊCH SỬ NẠP / RÚT </h4>
      </template>
      <template #default>
        <div >
          <b-table-simple hover small bordered responsive>
            <b-thead>
              <b-tr>
                <b-th>VND</b-th>
                <b-th>USD</b-th>
                <b-th>Ngày</b-th>
                <b-th>Ghi chú</b-th>
                <b-th></b-th>
              </b-tr>
            </b-thead>
            <b-tbody v-if="modal_ListPayment.length > 0">
              <b-tr v-for="row in modal_ListPayment" :key="`list-payment-${row.id}`">
                <b-td>
                   <span :style="applyNumberStyle(row.amount_vnd)">{{applyNumberFormat(row.amount_vnd,'th')}}</span>
                </b-td>
                <b-td>
                   <span :style="applyNumberStyle(row.amount_usd)">{{applyNumberFormat(row.amount_usd,'en')}}</span>
                </b-td>
                <b-td>
                  <span>{{row.created_at}}</span>
                </b-td>
                <b-td>
                  <span>{{row.note}}</span>
                </b-td>
                <b-td>
                   <a
                      data-toggle="tooltip"
                      data-placement="top"
                      title
                      data-original-title="Xóa"
                      @click="confirmDeleteHistoryModal(row.id, row.member_id)"
                    >
                      <i class="las la-trash-alt text-red"></i>
                    </a>
                </b-td>
              </b-tr>
            </b-tbody>
            <b-tbody v-else>
              <b-tr>
                <b-td colspan="4" class="text-center">
                  Chưa có dữ liệu nạp rút
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
      </template>
      <template #modal-footer>
        <b-button variant="default" @click="$bvModal.hide('modal-3')">Đóng</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { findash } from '../../../../config/pluginInit'
import _ from 'lodash'
import { applyNumberStyle, formatNumberByLocale } from '@/utils'
import { mapActions, mapGetters } from 'vuex'
import api from '@/store/api'
// import EditableNumber from '@/views/Report/components/EditableFields/EditableNumber'

export default {
  name: 'ReportAll',
  // components: { EditableNumber },
  async mounted () {
    findash.index()
  },
  created () {
  },
  props: [ 'id', 'detail' ],
  watch: {
    detail: function (newVal, oldVal) {
      if (newVal !== oldVal && newVal.all) {
        this.parseData(newVal)
      }
    }
  },
  filters: {
    uppercase: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.toUpperCase()
    }
  },
  data () {
    return {
      listReport: [],
      stt: 1,
      custom_id: 0,
      sumVND: 0,
      sumUSD: 0,
      sum_moi: 0,
      sum_no_cu: 0,
      sum_nap_rut: 0,
      customerList: null, // this could be load on state of vuex (using mapState and mapAction functions)
      modal: {
        customer: null,
        payment_cycle: null,
        money_type: null,
        payment_type: null,
        payment_amount: 0,
        note: ''
      },
      modal_default_params: {
        customer: null,
        payment_cycle: null,
        money_type: null,
        payment_type: null,
        payment_amount: 0,
        note: ''
      },
      modal_ListPayment: []
    }
  },
  computed: {
    ...mapGetters({
      'detailReport': 'Report/detailReportState',
      'customerOptions': 'Customer/listOptionsState',
      'rangeReportOptions': 'Report/rangeReportListOptionsState',
      'serverError': 'Setting/serverErrorsState',
      'serverRequesting': 'Setting/serverRequestingState'
    })
  },
  methods: {
    ...mapActions({
      'loadDetailReport': 'Report/loadDetailReport'
    }),
    skeletorData (data) {
      _.map(data, (e) => {
        let _stt = this.stt
        let haveUSD = e.all.usd !== 0 || e.transaction.usd !== 0 || e.owe.usd !== 0 || e.accounting.usd !== 0
        let haveVND = e.all.vnd !== 0 || e.transaction.vnd !== 0 || e.owe.vnd !== 0 || e.accounting.vnd !== 0
        let onlyUSD = haveUSD && !haveVND
        let onlyVND = haveVND && !haveUSD
        let bothCurrency = haveUSD && haveVND
        if (bothCurrency || onlyVND || onlyUSD) {
          _stt = this.stt++
        }
        return _.extend(e, { custom_id: this.custom_id++, stt: _stt, haveUSD, haveVND, bothCurrency, onlyUSD, onlyVND })
      })

      return data
    },
    applyNumberStyle (number) {
      return applyNumberStyle(number)
    },
    applyNumberFormat (number, locale) {
      return formatNumberByLocale(number, locale)
    },
    confirm () {
      let params = {
        'member_id': this.modal.customer,
        'report_id': this.modal.payment_cycle,
        'currency_id': this.modal.money_type,
        'type': this.modal.payment_type, // enum : payment/other
        'amount': this.modal.payment_amount,
        'note': this.modal.note // optional
      }

      api.transaction.create(params).then(() => {
        // reset form
        this.modal = this.modal_default_params
        this.loadDetailReport(this.detailReport.selected_report_id)

        this.$swal({
          icon: 'success',
          title: 'Thêm thành công'
        }).then(() => {
          this.$bvModal.hide('modal-2')
        })
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Lỗi...',
          text: this.serverError
        })
      })
    },
    parseData (newVal) {
      let sortedDetails = _.orderBy(newVal.all.details, (e) => {
        return e.name
      })

      this.listReport = this.skeletorData(sortedDetails)
      // reset
      this.stt = 1
    },
    openDepositModal (dataRow, currencyId, amount) {
      this.$root.$emit('bv::toggle::modal', 'modal-2')
      this.modal = {
        customer: dataRow.member_id,
        payment_cycle: this.detailReport.selected_report_id,
        money_type: currencyId,
        payment_type: 'payment',
        payment_amount: amount * -1,
        note: ''
      }
    },
    openHistoryModal (dataRow) {
      this.modal_ListPayment = _.filter(this.detailReport.payments, (item) => {
        return item.member_id === dataRow.member_id
      })
    },
    confirmDeleteHistoryModal (id, memberId) {
      this.$swal({
        title: 'Giao dịch',
        text: 'Bạn chắc chắn xóa giao dịch này ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Xóa',
        denyButtonText: `Hủy`
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          api.transaction.delete(id).then(async () => {
            this.$swal({
              icon: 'success',
              title: 'Xóa thành công'
            })

            await this.loadDetailReport(this.detailReport.selected_report_id)

            // reload data
            this.modal_ListPayment = _.filter(this.detailReport.payments, (item) => {
              return item.member_id === memberId
            })
          }).catch(() => {
            this.$swal({
              icon: 'error',
              title: 'Lỗi...',
              text: this.serverError
            })
          })
        } else if (result.isDenied) {

        }
      }).catch(() => {
      })
    }
  }
}
</script>
